module.exports = __webpack_public_path__ + "img/horizontal_3_1_3.0e8f11f6.png";